import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useStore } from 'effector-react';
import styled from 'styled-components';
import classNames from 'classnames';
import { $noti, $notiApi } from './notiStores';
import ImgClose from './img-close.png';
import Icon from '../Icon';
import { NotiType } from './notiTypes';

const duration = 300;
const tClassName = 'ntItem';

const Item = styled.div`
  max-width: 400px;
  padding: 10px 36px 10px 10px;

  &.${tClassName}-enter {
    opacity: 0.01;
    transform: translate3d(0%, -100%, 0);
  }
  &.${tClassName}-enter-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    transition:
      transform ${duration}ms ease-out,
      opacity ${duration}ms ease-out;
  }
  &.${tClassName}-exit {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  &.${tClassName}-exit-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
    transition:
      transform ${duration}ms ease-in,
      opacity ${duration}ms ease-in;
  }
`;

function Noti() {
  const list = useStore($noti);

  useEffect(() => {
    const unwatch = $notiApi.add.watch((payload) => {
      window.setTimeout(() => {
        $notiApi.remove(payload.id);
      }, 5000);
    });
    return () => {
      unwatch();
      $notiApi.clear();
    };
  }, []);

  return ReactDOM.createPortal(
    <div
      className="absolute left-1/2 top-65 -mr-1/2 -translate-x-1/2 transform text-base"
      style={{ zIndex: 12000 }}
    >
      <TransitionGroup className="flex flex-col items-center">
        {list.map((item) => (
          <CSSTransition
            key={item.id}
            timeout={duration}
            classNames={tClassName}
          >
            <Item
              className={classNames(
                'relative mb-20 cursor-pointer rounded text-white',
                {
                  'bg-orange': item.type === NotiType.warning,
                  'bg-green': item.type === NotiType.success,
                  'bg-red': item.type === NotiType.error,
                }
              )}
              onClick={() => $notiApi.remove(item.id)}
            >
              {item.message}
              <Icon src={ImgClose} className="absolute right-10 top-10 mt-2" />
            </Item>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>,
    document.body
  );
}

export default Noti;
